export default "__VITE_ASSET__DreK5m5f__"